import { render, staticRenderFns } from "./CompMailboxThanks.vue?vue&type=template&id=3cc1e6d5"
import script from "./CompMailboxThanks.vue?vue&type=script&setup=true&lang=js"
export * from "./CompMailboxThanks.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports